import { Resource, UserCourse } from './types';

export const formatCoursesToOptions = (courses: Array<Resource>, userCourseName: string): Array<UserCourse> => courses
  .filter(({ name }: Resource) => name !== userCourseName)
  .map(({ id, name }: Resource) => ({ label: name, value: id }));
